import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useControlledState as $fQ2SF$useControlledState } from "@react-stately/utils";
import { useMemo as $fQ2SF$useMemo, useState as $fQ2SF$useState } from "react";
var $a54cdc5c1942b639$var$instance = Math.round(Math.random() * 10000000000);
var $a54cdc5c1942b639$var$i = 0;
function $a54cdc5c1942b639$export$bca9d026f8e704eb(props) {
  // Preserved here for backward compatibility. React Aria now generates the name instead of stately.
  var name = $fQ2SF$useMemo(function () {
    return props.name || "radio-group-".concat($a54cdc5c1942b639$var$instance, "-").concat(++$a54cdc5c1942b639$var$i);
  }, [props.name]);
  var _$fQ2SF$useControlled = $fQ2SF$useControlledState(props.value, props.defaultValue, props.onChange),
    _$fQ2SF$useControlled2 = _slicedToArray(_$fQ2SF$useControlled, 2),
    selectedValue = _$fQ2SF$useControlled2[0],
    setSelected = _$fQ2SF$useControlled2[1];
  var _$fQ2SF$useState = $fQ2SF$useState(null),
    _$fQ2SF$useState2 = _slicedToArray(_$fQ2SF$useState, 2),
    lastFocusedValue = _$fQ2SF$useState2[0],
    setLastFocusedValue = _$fQ2SF$useState2[1];
  var setSelectedValue = function setSelectedValue(value) {
    if (!props.isReadOnly && !props.isDisabled) setSelected(value);
  };
  return {
    name: name,
    selectedValue: selectedValue,
    setSelectedValue: setSelectedValue,
    lastFocusedValue: lastFocusedValue,
    setLastFocusedValue: setLastFocusedValue,
    isDisabled: props.isDisabled || false,
    isReadOnly: props.isReadOnly || false
  };
}
export { $a54cdc5c1942b639$export$bca9d026f8e704eb as useRadioGroupState };